<template>
  <div class="detail-page-footer">
    <v-row class="detail-page-footer__content">
      <p class="detail-page-footer__text">
        Want to see all pricing information?
      </p>
      <v-btn class="detail-page-footer__button" to="/checkout">
        Upgrade now
      </v-btn>
    </v-row>
  </div>
</template>

<script>
export default {};
</script>

<style>
.detail-page-footer {
  bottom: 0;
  width: 100vw;
  height: 184px;
  display: flex;
  background-color: #fff5d5;
  background-image: url(../assets/footer-vector-blue.png),
    url(../assets/footer-vector-pink.png);
  background-position: 5% top, right bottom;
  background-repeat: no-repeat, no-repeat;
}

.detail-page-footer__content {
  justify-content: center;
  align-items: center;
  margin: 0;
}

.detail-page-footer__text {
  margin-bottom: 0 !important;
  margin-right: 24px;
  font-weight: 500;
  font-size: 26px;
  line-height: 30px;
  letter-spacing: -0.5px;
  max-width: 730px;
}
.detail-page-footer__button.v-btn {
  box-shadow: none;
  padding: 16px 26px !important;
  background-color: #030134 !important;
  height: unset !important;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
  border-radius: 12px;
}

@media (max-width: 768px) {
  .detail-page-footer {
    height: auto;
  }
  .detail-page-footer__content {
    justify-content: flex-start;
    padding: 65px 16px;
  }
  .detail-page-footer__text {
    margin-bottom: 24px !important;
    font-size: 16px;
  }
}
</style>
